import { Button } from '@/components/ui/button';

type PatientStepFooterProps = {
  onSubmit: () => void;
  isSaving: boolean;
  // Save failure not tied to a field, shown above the button.
  submitError?: string;
  disabled?: boolean;
};

export const PatientStepFooter = ({
  onSubmit,
  isSaving,
  submitError,
  disabled,
}: PatientStepFooterProps) => (
  <div className="flex flex-col w-full items-center">
    {submitError && (
      <p className="mb-2 text-2xs font-light text-red-600" role="alert">
        {submitError}
      </p>
    )}
    <Button
      variant="ctaPrimary"
      size="lg"
      onClick={onSubmit}
      disabled={isSaving || disabled}
    >
      Continuer
    </Button>
  </div>
);
